import React, { Component } from 'react'
import { connect } from 'react-redux'

import trads from '~/intl/trads.json'

import Slider from '~/components/core/slider'
import LinkIcon from '~/components/core/linkIcon'

class SliderPartners extends Component {
  constructor(props, context) {
    super(props, context)
    this.state = {
      hasSlider: false,
    }
  }

  componentDidMount() {
    this.controlDisplay('init')
    window.addEventListener('orientationchange', this.controlDisplay('resize'))
  }

  componentWillUnmount() {
    window.removeEventListener(
      'orientationchange',
      this.controlDisplay('resize'),
    )
  }

  controlDisplay(type) {
    let windowWidth = type === 'init' ? window.innerWidth : window.screen.width
    let hasSlider = true
    let itemsCount = this.props.data.fields
      ? this.props.data.fields.items.length
      : this.props.data.items.length

    const { isAction } = this.props

    if (windowWidth >= 1280) {
      const limit = isAction ? 3 : 4
      hasSlider = itemsCount > limit ? true : false
    } else if (windowWidth >= 768) {
      const limit = isAction ? 2 : 3
      hasSlider = itemsCount > limit ? true : false
    }

    this.setState({ hasSlider: hasSlider })
  }

  render() {
    const { data, lang, isAction } = this.props

    const flickityOptions = {
      cellAlign: 'left',
      contain: true,
      pageDots: false,
      prevNextButtons: false,
      groupCells: true,
      wrapAround: true,
    }

    let items = data.fields ? data.fields.items : data.items

    return (
      <div className="full-width-mobile overflow-hidden">
        <div className="row">
          <div
            className={`col-12 ${isAction ? 'lg-col-7' : 'lg-col-8'} lg-col-offset-1`}
          >
            {!isAction ? (
              <h2 className="text-label text-label--big text-label--bg bg-purple text-white mb-8">
                {data.title}
              </h2>
            ) : (
              <h2 className="title-block text-blue title-block--no-margin pb-4">
                {trads[lang].project.partners}
              </h2>
            )}

            <div
              className={`slider-partners ${this.state.hasSlider ? '' : 'flex'}`}
            >
              {this.state.hasSlider ? (
                <Slider
                  flickityOptions={flickityOptions}
                  classes="slider-partner__slider"
                  navClasses="w-full text-center md:text-left"
                  iconColor="purple"
                >
                  {items.map((item, i) => {
                    return (
                      <Item
                        item={item}
                        lang={lang}
                        key={i}
                        isAction={isAction}
                      />
                    )
                  })}
                </Slider>
              ) : (
                items.map((item, i) => {
                  return (
                    <Item item={item} lang={lang} key={i} isAction={isAction} />
                  )
                })
              )}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const Item = ({ item, lang, isAction }) => {
  const partner = item.fields ? item.fields : item
  const logo = item.fields ? partner.logo.fields : partner.logo
  const logoFile = item.fields ? logo.file.fields.file.url : logo.file.file.url

  /* eslint-disable */
  return (
    <div
      className={`partner__slide ${isAction ? 'partner__slide--action' : ''}`}
    >
      <a
        href={partner.link}
        target="_blank"
        rel={`noopener noreferrer ${partner.noFollow ? 'nofollow' : ''}`}
        className={`partner ${isAction ? 'partner--action' : ''}`}
      >
        <div className="media">
          <img src={logoFile} alt={logo.altImage} />
        </div>

        <div className="flex-shrink-0">
          <LinkIcon text={trads[lang].goWebsite} />
        </div>
      </a>
    </div>
  )
  /* eslint-enable */
}

const mapStateToProps = ({ lang }) => {
  return { lang }
}

export default connect(mapStateToProps, null)(SliderPartners)
